
import { useEffect, useState } from "react";

import { registrosService } from "../../../_services/registros.service";
import { Tabla } from "../../../components/Table/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTasks } from "@fortawesome/free-solid-svg-icons";

const Registros = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      let res = await registrosService.getRegistros();

      setData(res);
    };
    getData();
  }, []);

  const columns = [
    {
      title: "Inmueble",
      dataIndex: "inmueble",
    },
    {
      title: "Recurso",
      dataIndex: "recurso",
    },
    {
      title: "Apellido y Nombre",
      dataIndex: "apellido_nombre",
    },
    {
      title: "Titulo",
      dataIndex: "titulo",
    },
    {
      title: "DNI",
      dataIndex: "dni",
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      width: "30%",
    },
    {
      title: "Subido por",
      dataIndex: "asignado",
    },
    {
      title: "Documentos",
      dataIndex: "documentos",
    },
  ];

  const formatData = (arrayData) => {
    try {
      return arrayData.map(item => {
        const { apellido, nombre, user, registro_documentos } = item;

        return {
          ...item,
          apellido_nombre: `${apellido?.toUpperCase()}, ${nombre}`,
          asignado: `${user.apellido?.toUpperCase()}, ${user.nombre} (${user.abogado})`,
          documentos:  registro_documentos?.length ? (
            <div>
              <ul>
                {registro_documentos.map((e, i) => {
                  return (
                    <li key={(e.name || e.documento) + i}>         
                      <a
                        href={"https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/registros/" + e.documento}
                        key={e.documento}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {e.documento}
                      </a> 
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null          
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  return (
    <div className="section-content">
      <div className="section-title d-flex align-items-center">
        <FontAwesomeIcon icon={faTasks} style={{ fontSize: 34, color: "#999999" }} />
        <span>Registros</span>
      </div>
      <Tabla dataList={formatData(data)} columns={columns} />
    </div>
  );
};


export default Registros;